// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiDomain: 'https://api.ergo-plusdev.com',
  googlePlacesApiKey: 'AIzaSyCQn67mV8tc5KoRnIIl3mF4Xs1wITgKloU',
  analyticsKey: 'UA-22713531-1',
  clientId: 'ergoplus-industrial-ui',
  clientSecret: 'd2JNRGVudDhYUjZwNVVSWTA4UHM=',
  stripePublishableKey: 'pk_test_h7VNWUDjiQi13cocQNpWyLj6',
  productAnalyticsKey: '1634447297',
  intercomAppId: 'ho3945zl',
  mixpanelToken: '',
  integrationDomain: 'localhost:4201',
  oauthClientId: '20d0b8ae349d3a2582b2d89a5caf3d1180a84d77',
};
